var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8859 10.0003L18.9431 17.0575C19.4638 17.5782 19.4638 18.4224 18.9431 18.9431C18.4224 19.4638 17.5782 19.4638 17.0575 18.9431L10.0003 11.8859L2.94313 18.9431C2.42244 19.4638 1.57822 19.4638 1.05752 18.9431C0.536817 18.4224 0.536817 17.5782 1.05752 17.0575L8.11471 10.0003L1.05752 2.94313C0.536817 2.42244 0.536817 1.57822 1.05752 1.05752C1.57822 0.536817 2.42244 0.536817 2.94313 1.05752L10.0003 8.11471L17.0575 1.05752C17.5782 0.536817 18.4224 0.536817 18.9431 1.05752C19.4638 1.57822 19.4638 2.42244 18.9431 2.94313L11.8859 10.0003Z",
    fill: "#2C3439"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.a83f95dbbf2b872c7d8fcf40cc46ed9e.svg";
export { ForwardRef as ReactComponent };